import { useRef, useEffect, useState } from "react";

interface MarqueeProps {
  text: string;
}

export function Marquee({ text }: MarqueeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const [duration, setDuration] = useState(10); // default duration

  useEffect(() => {
    if (containerRef.current && textRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.scrollWidth;

      // Base speed: pixels per second
      const speed = 100; // adjust speed as needed
      const newDuration = textWidth > containerWidth ? textWidth / speed : containerWidth / speed;

      setDuration(newDuration);
    }
  }, [text]);

  return (
    <div
      ref={containerRef}
      className="overflow-hidden relative w-full h-5"
    >
      <div
        ref={textRef}
        className="absolute whitespace-nowrap font-medium text-gray-600,"
        style={{
          animation: `marquee ${duration}s linear infinite`,
        }}
      >
        {text} &nbsp;&nbsp;&nbsp; {text}
      </div>
    </div>
  );
}

